import React, { useEffect } from "react"
import { motion, useReducedMotion, useAnimation } from "framer-motion"
import useIsInViewport from "use-is-in-viewport"

const svgVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 2,
      ease: "easeOut",
    },
  },
}

const handVariants = {
  hidden: {
    pathLength: 0,
    pathOffset: 0.75,
  },
  visible: {
    pathLength: 1,
    pathOffset: 0,
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
}

const globeVariants = {
  hidden: {
    rotate: -90,
    scale: 0.5,
  },
  visible: {
    rotate: 0,
    scale: 1,
    transition: {
      duration: 1.5,
      ease: "backInOut",
    },
  },
}

export default function MotionIconHandGlobe() {
  const reducedMotion = useReducedMotion()
  const controls = useAnimation()
  const [isIconInViewport, icon] = useIsInViewport()

  useEffect(() => {
    if (isIconInViewport) {
      controls.start("visible")
    }
    if (!isIconInViewport) {
      controls.start("hidden")
    }
  }, [controls, isIconInViewport])

  return (
    <motion.svg
      ref={icon}
      id="motion-icon-hand-globe"
      className="motion-icon"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 66 35"
      variants={reducedMotion ? null : svgVariants}
      initial="hidden"
      animate={controls}
    >
      <motion.path
        id="hand"
        fill="none"
        stroke="#000"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M34 7.7h22c1.8 0 3.2 1.5 3.2 3.2v0c0 1.8-1.5 3.2-3.2 3.2H34h27c1.8 0 3.2 1.5 3.2 3.2v0c0 1.8-1.5 3.2-3.2 3.2H34h22c1.8 0 3.2 1.5 3.2 3.2v0c0 1.8-1.5 3.2-3.2 3.2H34h8.3c2.8 0 5 2.2 5 5v1.5H17.5c-8.9 0-16.2-7.3-16.2-16.2s7.2-16 16.2-16H45c1.8 0 3.2 1.5 3.2 3.2v0c0 1.8-1.5 3.2-3.2 3.2H34z"
        variants={reducedMotion ? null : handVariants}
      />
      <motion.g
        id="globe"
        style={{ originX: "26.43%", originY: "49.85%" }}
        variants={reducedMotion ? null : globeVariants}
      >
        <g id="solids">
          <path
            id="solid-1"
            d="M17.5 5.9C11.1 5.9 6 11.1 6 17.4h4.9c-.1-6.3 2.9-11.5 6.6-11.5z"
            fill="#95d6da"
          />
          <path
            id="solid-2"
            d="M10.8 17.5h6.6V5.9c-3.6 0-6.6 5.2-6.6 11.6z"
            fill="#afc79e"
          />
          <path
            id="solid-3"
            d="M24.1 17.5c0-6.4-3-11.5-6.6-11.5v11.5h6.6z"
            fill="#fff"
          />
          <path
            id="solid-4"
            d="M24.1 17.5H29C29 11.1 23.8 6 17.5 6c3.6-.1 6.6 5.1 6.6 11.5z"
            fill="#f7d995"
          />
          <path
            id="solid-5"
            d="M10.8 17.5H5.9c0 6.4 5.2 11.5 11.5 11.5-3.6 0-6.6-5.2-6.6-11.5z"
            fill="#fff"
          />
          <path
            id="solid-6"
            d="M10.8 17.5c0 6.4 3 11.5 6.6 11.5V17.5h-6.6z"
            fill="#e99b95"
          />
          <path
            id="solid-7"
            d="M24.1 17.5h-6.6V29c3.6 0 6.6-5.2 6.6-11.5z"
            fill="#939fc8"
          />
          <path
            id="solid-8"
            d="M24.1 17.5c0 6.4-3 11.5-6.6 11.5C23.8 29 29 23.8 29 17.5h-4.9z"
            fill="#afb1b3"
          />
        </g>
        <g id="lines" fill="none" stroke="#00b2b8" strokeWidth="2">
          <circle id="outer" cx="17.5" cy="17.5" r="11.5" />
          <ellipse id="inner" cx="17.5" cy="17.5" rx="6.6" ry="11.5" />
          <path id="vertical" d="M17.5 5.9V29" />
          <path id="horizontal" d="M29 17.5H5.9" />
        </g>
      </motion.g>
    </motion.svg>
  )
}
